import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "less--sprite",
  "use": "less--sprite-usage",
  "viewBox": "0 0 8 1.33333",
  "content": "<symbol viewBox=\"0 0 8 1.33333\" xmlns=\"http://www.w3.org/2000/svg\" id=\"less--sprite\">\n<path d=\"M0 0H8V1.33333H0V0Z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol